import { render, staticRenderFns } from "./uBindCustomerForm.vue?vue&type=template&id=14d9e44e&scoped=true&"
import script from "./uBindCustomerForm.vue?vue&type=script&lang=js&"
export * from "./uBindCustomerForm.vue?vue&type=script&lang=js&"
import style0 from "./uBindCustomerForm.vue?vue&type=style&index=0&id=14d9e44e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d9e44e",
  null
  
)

export default component.exports